{
  "dataType": {
    "products": "products",
    "customers": "customers",
    "merchant": "merchants",
    "purchases": "purchases",
    "pricing": "prices"
  }
}
